export const siteInfo = {
  name: "羞羞歪歪漫画",
  slogan: "全网最全漫画资源，免费无删减竖屏阅读",
  description: "羞羞歪歪漫画是一个专注于提供高质量漫画阅读体验的在线平台，涵盖恋爱、热血、奇幻、搞笑、悬疑、校园、都市、古风、科幻等多种类型漫画。全部章节无删减，支持下拉式竖屏阅读，随时随地畅享漫画世界。",
  founded: "2024",
  email: "contact@xiuxiuwaiwai.com",
  features: [
    {
      title: "海量资源",
      description: "收录超过10000+部热门漫画，涵盖恋爱、热血、奇幻、搞笑、悬疑、校园、都市、古风、科幻等丰富类型，满足不同读者的阅读偏好。",
      icon: "ri-database-2-line",
    },
    {
      title: "完全免费",
      description: "所有漫画资源完全免费阅读，无需付费订阅，无需会员充值。我们致力于让每一位漫画爱好者都能无障碍地享受阅读的乐趣。",
      icon: "ri-money-cny-circle-line",
    },
    {
      title: "无删减内容",
      description: "全部章节保持原版内容，不做任何删减和修改。尊重创作者的原意，为读者呈现最完整、最真实的漫画故事体验。",
      icon: "ri-file-copy-2-line",
    },
    {
      title: "竖屏阅读",
      description: "专为移动端优化的下拉式竖屏阅读模式，完美适配手机屏幕。流畅的滑动体验，让你躺着也能轻松看漫画，随时随地沉浸其中。",
      icon: "ri-smartphone-line",
    },
    {
      title: "极速更新",
      description: "与各大漫画平台同步更新，热门漫画每日更新。第一时间获取最新章节，不再错过任何精彩剧情，追更体验一流。",
      icon: "ri-speed-up-line",
    },
    {
      title: "高清画质",
      description: "所有漫画均采用高清图片压缩技术，在保证加载速度的同时呈现最佳画面质量。每一格分镜都清晰细腻，带来极致视觉享受。",
      icon: "ri-hd-line",
    },
  ],
  stats: [
    { value: "10000+", label: "漫画资源" },
    { value: "500万+", label: "月活用户" },
    { value: "99.8%", label: "用户好评" },
    { value: "24h", label: "实时更新" },
  ],
};